<template>
  <div class="content">
    <div class="header">
      <div style="margin: 5px 0">
        <SelectCdjProjectHeader @onHeader="onHeader" />
      </div>
    </div>

    <div class="body">
      <el-tabs type="border-card" v-model="card_index">
        <el-tab-pane label="欠费房产" name="LossLegalHoseLayout">
          <LossLegalHoseLayout v-if="card_index==='LossLegalHoseLayout'" />
        </el-tab-pane>
        <el-tab-pane label="催缴房产" name="LegalHousePlan">
          <LegalHousePlan v-if="card_index==='LegalHousePlan'&&is_loading" />
<!--          <LegalHoseLayout v-if="card_index==='LegalHousePlan'" />-->
        </el-tab-pane>

        <el-tab-pane label="年度诉讼计划" name="ExpeditingFeesPlanContenziosoLayout">
<!--          <ExpeditingFeesPlanContenzioso v-if="card_index==='ExpeditingFeesPlanContenzioso'" />-->
          <ExpeditingFeesPlanContenziosoLayout v-if="card_index==='ExpeditingFeesPlanContenziosoLayout'" />
        </el-tab-pane>
        <el-tab-pane label="月度诉讼计划" name="ExpeditingFeesPlanYearMonth">
          <ExpeditingFeesPlanYearMonth v-if="card_index==='ExpeditingFeesPlanYearMonth'" />
        </el-tab-pane>
        <el-tab-pane label="月度自催/第三方催费计划" name="LegalHouseAge">
          <LegalHouseAge v-if="card_index==='LegalHouseAge'" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import moment from "moment/moment";
import ExpeditingFeesPlanYearMonth from "./components/plan/ExpeditingFeesPlanYearMonth";
import LegalHousePlan from "./components/plan/LegalHousePlan";
import ThirdPartyLegalMainPlan from "./components/plan/ThirdPartyLegalMainPlan";
import ExpeditingFeesPlanContenzioso from "./components/plan/ExpeditingFeesPlanContenzioso";
import LossLegalHousePlan from "./components/plan/LossLegalHousePlan";
import LossLegalHoseLayout from "./components/plan/LossLegalHoseLayout";
import LegalHoseLayout from "./components/plan/LegalHoseLayout";
import LegalHouseAge from "./components/plan/LegalHouseAge";
import ExpeditingFeesPlanContenziosoLayout from "./components/plan/ExpeditingFeesPlanContenziosoLayout";
import SelectCdjProjectHeader from "./components/common/SelectCdjProjectHeader";

export default {
  name: "ExpeditingFeesPlan",
  components: {
    SelectCdjProjectHeader,
    ExpeditingFeesPlanContenziosoLayout,
    LegalHouseAge,
    LegalHoseLayout,
    LossLegalHoseLayout,
    LossLegalHousePlan,
    ExpeditingFeesPlanContenzioso, ThirdPartyLegalMainPlan, LegalHousePlan, ExpeditingFeesPlanYearMonth},
  provide(){
    return{
      where:this.where,
      reginWhere:this.reginWhere
    }
  },
  data(){
    return{
      is_loading:false,
      where: {
        text:"",
        is_authentication:"",
        start_time:moment(new Date()).format("YYYY-MM"),
        end_time:moment(new Date()).format("YYYY-MM"),
      },
      reginWhere:{
        type_id:"",
        type_list:[],
        project_region:"",
        project_region_list:[],
        project_region_level:"",
        project_name:"",
        project_list:[],
        group_by:"",
        area_id:"",
        area_list:[],
        project_ids:[],
        level:0
      },
      card_index:"LegalHousePlan"
    }
  },
  activated() {
    const that=this;
    if(that.$route.query.card_index){
      that.card_index=that.$route.query.card_index
    }
  },
  methods:{
    rpx(rp){
      // return
    },

    onHeader(data){
      const that=this;
      that.reginWhere.type_id=data.type_id;
      that.reginWhere.type_list=data.type_list;
      that.reginWhere.project_region=data.project_region;
      that.reginWhere.project_region_list=data.project_region_list;
      that.reginWhere.project_region_level=data.project_region_level;
      that.reginWhere.project_name=data.project_name;
      that.reginWhere.project_list=data.project_list;
      that.reginWhere.group_by=data.group_by;
      that.reginWhere.area_id=data.area_id;
      that.reginWhere.area_list=data.area_list;
      that.reginWhere.project_ids=data.project_ids;
      that.reginWhere.level=data.level;
      that.is_loading=true;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "common";
.content{
  padding: 10px;
  margin-left: 10px;

  .header{
    padding-top: 5px;
    padding-bottom: 10px;
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background-color: #FFFFFF;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/ExpeditingFeesPlan.vue